export const PRODUCT_PLACEHOLDER = "/product-placeholder.svg";

// Resolve a product image src, falling back to the branded placeholder when empty.
export const productImage = (url) => (url && String(url).trim() ? url : PRODUCT_PLACEHOLDER);

// onError handler: swap a broken image for the placeholder (once).
export const onImgError = (e) => {
  if (e.currentTarget.src.indexOf(PRODUCT_PLACEHOLDER) === -1) {
    e.currentTarget.src = PRODUCT_PLACEHOLDER;
  }
};

// Client-side downscale + JPEG compress before upload (keeps big phone photos small).
// Falls back to the original file if the browser can't decode it (e.g. some HEIC).
export const compressImageFile = (file, maxDim = 1600, quality = 0.85) =>
  new Promise((resolve) => {
    try {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        URL.revokeObjectURL(url);
        let { width, height } = img;
        if (Math.max(width, height) > maxDim) {
          const s = maxDim / Math.max(width, height);
          width = Math.round(width * s);
          height = Math.round(height * s);
        }
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          (blob) => resolve(blob ? new File([blob], "upload.jpg", { type: "image/jpeg" }) : file),
          "image/jpeg",
          quality
        );
      };
      img.onerror = () => {
        URL.revokeObjectURL(url);
        resolve(file);
      };
      img.src = url;
    } catch {
      resolve(file);
    }
  });
